module.exports = __webpack_public_path__ + "static/bar01_5_mobile-8e3782ae2f0349b71c1026813130edcd.png";